// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3sqW2","tab":"Tabs_tab__1in9-","tabActive":"Tabs_tabActive__3_jCN"};